import { breakpointsMap } from '@oneaudi/unified-web-common';
import { urlQueryStringToObj } from './urlQueryStringToObj';
import { objToStr } from './objToStr';

const imgSize = {
  '320px': 290,
  '375px': 344,
  '768px': 738,
  '1024px': 446,
  '1440px': 654,
  '1920px': 915,
};

export const setAssetParams = (assetMediaArray, assetContainerLabel, isTest) => {
  const videoSrcs = assetMediaArray.video.srcs;
  const imageSrcs = assetMediaArray.image.srcSet;

  if (isTest) return assetContainerLabel;

  if (Array.isArray(videoSrcs)) {
    setVideoParams(videoSrcs);
    return {
      ...assetMediaArray,
      video: { ...assetMediaArray.video, srcs: videoSrcs },
    };
  }

  if (Array.isArray(imageSrcs)) {
    const { srcSet, src } = setImgParams(imageSrcs);
    return { ...assetMediaArray, image: { ...assetMediaArray.image, srcSet, src } };
  }
};

const setVideoParams = (videoSrcs) => {
  const objKeys = Object.keys(videoSrcs);

  objKeys.forEach((key) => {
    if (videoSrcs[`${key}`].poster !== '' && videoSrcs[`${key}`].poster.includes('jpg')) {
      const [slideImageSrc, slideImageSrcQueryParams] = videoSrcs[`${key}`].poster.split('?');

      const slideImageSrcQueryParamsObj = urlQueryStringToObj(slideImageSrcQueryParams);

      slideImageSrcQueryParamsObj.preferwebp = 'true';

      slideImageSrcQueryParamsObj.width = '915';

      const src = `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)}`;
      // eslint-disable-next-line no-param-reassign
      videoSrcs[`${key}`].poster = src;
    }
  });
};

const setImgParams = (imageSrcs) => {
  const srcSet = [];
  let src = '';

  imageSrcs.forEach((imgObj) => {
    const [slideImageSrc, slideImageSrcQueryParams] = imgObj.src.split('?');
    const slideImageSrcQueryParamsObj = urlQueryStringToObj(slideImageSrcQueryParams);
    slideImageSrcQueryParamsObj.preferwebp = 'true';
    slideImageSrcQueryParamsObj.width = `${imgSize[breakpointsMap[imgObj.bp]]}`;
    src = slideImageSrc;

    // eslint-disable-next-line no-param-reassign
    imgObj.src = `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)}`;
    srcSet.push(
      `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)} ${imgSize[breakpointsMap[imgObj.bp]]}w`,
    );
  });

  return { srcSet, src };
};
